import React, { useState } from 'react';
import classNames from 'classnames';
import styles from '../assets/internal-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IInternal } from 'src/types/internal';
import InternalActionsColumn from './InternalActionsColumn';
import { CellProps } from 'react-table';
import GeneralEnumService from 'src/enumerables/general-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import dropdownFilter from 'src/components/react-table/filters/dropdown-filter';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { ICase } from 'src/types/case';
import dateFilterMulti from 'src/components/react-table/filters/date-filter-multi';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import { numberWithCommas } from '../../../../../../../helpers/format';

interface Props {
    data: Paginated<IInternal>;
    providers: SelectObject[];
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}

const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('InternalStatus') : {};
const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
const getColumns = (dataProd: SelectObject[]): Column<IInternal>[] => [
    {
        Header: 'Date',
        accessor: 'internalDate',
        headerClassName: 'text-center w-100 d-block',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInternal>) => {
            return (
                <div className={'text-center'}>
                    {original.internalDate ? changeToZeroMoment(original.internalDate, 'MMM D, YYYY') : ''}
                </div>
            );
        },
        Filter: dateFilterMulti<IInternal>(),
    },
    {
        Header: 'Provider',
        accessor: 'provider.id',
        disableSortBy: true,
        Filter: dropdownFilter<IInternal>(dataProd),
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInternal>) => {
            if (!original?.provider) return '';

            return (
                <Link
                    to={Router.generate(routes.PROVIDER_DETAIL, {
                        id: original?.provider?.id,
                        tab: 'main-info',
                        subId: '',
                    })}
                >
                    {original.provider?.fullName}
                </Link>
            );
        },
    },

    {
        Header: 'Amount',
        accessor: 'amount',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IInternal>) => {
            return original.amount ? `$${numberWithCommas(original.amount)}` : null;
        },
    },
    {
        Header: 'Comment',
        accessor: 'description',
        disableSortBy: true,
        disableFilters: true,
        Filter: textFilter<IInternal>(),
    },

    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<ICase>) => {
            const valueCaseStatus = statusItems.find((it) => it.value === original.status);
            return valueCaseStatus ? valueCaseStatus.label : '';
        },
        Filter: dropdownFilter<IInternal>(statusItems),
    },

    {
        Header: 'Actions',
        accessor: 'id',
        Cell: InternalActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const InternalsGrid: React.FunctionComponent<Props> = ({ data, providers, getDataCsv, getData }: Props) => {
    const [columns, setColumns] = useState<any>([]);

    if (providers.length && !columns.length) {
        setColumns(getColumns(providers));
    }
    return (
        <div className={classNames(styles.grid)}>
            <Grid<IInternal> columns={columns} data={data} getDataCsv={getDataCsv} getData={getData} />
        </div>
    );
};

export default InternalsGrid;
